import React from "react"
import BaseModal from "helper/component/basemodal";
import { localize } from "services/base";
import { msg } from "signals/modal";

const Message = () => {
      const t = (key) => localize(key)
      return (
            <BaseModal tag={"message"}>
                  <p className="message-content text-center my-3">{t(msg)}</p>
            </BaseModal>
      )
}

export default Message;
